import React, { useState, useEffect, useContext } from 'react';
import Loader from '../../components/utilities/Loader';
import { ConfigConstantsContext } from '../../components/Hooks/useConfigConstants';


const RedirectManageUser = () => {
    const {configDetails, loading} = useContext(ConfigConstantsContext)

    useEffect(()=>{
        sessionStorage.setItem("config",configDetails)
        setTimeout(()=>{
            window.location.href = "/ManageUser"
       },2000)
    },[loading])

    return (
        <>
           {loading && <Loader></Loader>}
        </>
    )
}

export default RedirectManageUser

